/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCpu = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 2v2h4V2h2.001v2H20v3.998l2 .001V10l-2-.001V14h2v2h-2v4h-3.999v2H14v-2h-4v2H8v-2H4v-4H2v-2h2V9.999L2 10V8l2-.001V4h4V2zm8 4H6v12h12zm-2 2v8H8V8zm-2 2h-4v4h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCpu as Cpu };
